import type { PermissionMatchMode } from '../types/permission.types';

export function checkPermissions<T>(
  permissions: T[],
  predicate: (permission: T) => boolean,
  matchMode: PermissionMatchMode = 'all',
): boolean {
  if (permissions.length === 0) return true;
  return matchMode === 'any'
    ? permissions.some(predicate)
    : permissions.every(predicate);
}
